import React, { useContext } from 'react';
import Head from 'next/head';
import { Product, Organization } from 'schema-dts';
import { BuildingPageContextInterface } from 'apolloClient/types/Building';
import { BuildingPageContext } from 'pages/[urlParam]/[urlBuildParam]';
import { getBuildingSchemaPrice } from 'src/utils/buildingUtils';

const BuildingProductSchema: React.FC = () => {
  const { building, url } = useContext(
    BuildingPageContext
  ) as BuildingPageContextInterface;

  const image = building.mainImage?.data?.attributes?.url;

  const price = getBuildingSchemaPrice(building.buildingStats);

  const organization: Organization = {
    '@type': 'Organization',
    name: 'CONDO BLACK BOOK',
    email: 'contact@condoblackbook.com',
    telephone: '+1 (305) 697-7667',
  };

  const product: Product = {
    '@type': 'Product',
    name: building.name,
    image,
    offers: [
      {
        '@type': 'Offer',
        price,
        availability:
          (building.buildingStats?.saleCount ?? 0) > 0 ||
          (building.buildingStats?.rentCount ?? 0) > 0
            ? 'InStock'
            : 'SoldOut',
        name: building.name,
        image,
        seller: organization,
        priceCurrency: 'USD',
        offeredBy: organization,
        itemCondition: 'NewCondition',
        url,
        priceSpecification: {
          '@type': 'PriceSpecification',
          url,
          name: building.name,
          priceCurrency: 'USD',
          price,
        },
      },
    ],
    brand: organization,
    url,
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    ...product,
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </Head>
  );
};

export default BuildingProductSchema;
